import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";
import ReactDOMServer from "react-dom/server";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";

///  <NUEVO PARA NOTIFICAR SIM>
import SweetAlert from "react-bootstrap-sweetalert";
///  </NUEVO PARA NOTIFICAR SIM>
import Iframe from "react-iframe";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLastfmSquare } from "@fortawesome/free-brands-svg-icons";
import moment from "moment";
import "moment/locale/es";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
import Cookies from "universal-cookie";

const cookies = new Cookies();

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

const CONFIRMAR_SIM = "SIM";
class Tickets extends React.Component {
  constructor(props) {
    super(props);
    /* //console.log("########## PROPS ###########");
    //console.log(props); */
    this.state = {
      servicesSize: 3,
      ticketsColsSize: {
        xs: 6,
        md: 2,
        lg: 2
      },
      ticketsStatisticsColsSize: {
        xs: 6,
        md: 3,
        lg: 3
      },
      filters: {}
    };
    this.redirectTo = this.redirectTo.bind(this);
    this.buildTicketsStatistics = this.buildTicketsStatistics.bind(this);
    this.passFilter = this.passFilter.bind(this);
    this.getDepartments = this.getDepartments.bind(this);
  }
  componentDidMount() {
    this.props.list_support_tickets();
    this.props.get_tickets_statistics();
    let tickets_filters = cookies.get("tickets_filters");
    // console.log("########## COOKIES FILTERS ###########", tickets_filters);
    if (tickets_filters) {
      this.setState({
        filters: tickets_filters
      });
    }
  }
  componentDidUpdate() {
    // console.log("filters", this.state.filters);
    let filters_string = JSON.stringify(this.state.filters);
    // console.log("filters_string", filters_string);
    cookies.set("tickets_filters", filters_string, {
      path: "/"
    });
    // console.log("Configuración guardada en cookies");
    // console.log(cookies.get('myCat')); // Pacman
  }
  getDepartments() {
    let statistics = this.props.state.tickets_statistics;
    let departments = [];
    let departments_options = [];
    if (statistics) {
      departments = statistics.departments;
      Object.keys(departments).map(department => {
        department = departments[department];
        departments_options.push({
          label: this.buildTicketDepartment(department),
          value: department.id
        });
      });
    }

    // console.log("departments options", departments_options);

    return departments_options;
  }
  getCategories() {
    let statistics = this.props.state.tickets_statistics;
    let categories = [];
    let categories_options = [];
    if (statistics) {
      categories = statistics.categories;
      Object.keys(categories).map(category => {
        category = categories[category];
        categories_options.push({
          label: this.buildTicketCategory(category),
          value: category.id
        });
      });
    }

    // console.log("departments options", departments_options);

    return categories_options;
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      confirmICC: "",
      ICC: "",
      confirmingDelivery: "",
      fieldStates: []
    });
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case CONFIRMAR_SIM:
        this.deliverySIMConfirmation();
        break;
      default:;
    }
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case CONFIRMAR_SIM:
        return this.createConfirmSIMDeliveryPopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  buildTicketDepartment(department) {
    if (!department) return null;
    // console.log("department", department);
    let department_id = parseInt(department.id);
    let department_name = department.name;
    let department_class = "";
    let department_icon = "";
    switch (department_id) {
      case 109: // Facturacion
        department_class = "facturacion";
        department_icon = "business_money-coins";
        break;
      case 120: // Marketing
        department_class = "marketing";
        department_icon = "shopping_bag-16";
        break;
      case 307: // Programación
        department_class = "programacion";
        department_icon = "education_glasses";
        break;
      case 108: // Técnico
        department_class = "tecnico";
        department_icon = "objects_support-17";
        break;
      case 308: // Redes
        department_class = "redes";
        department_icon = "media-2_sound-wave";
        break;
      case 306: // Sistemas
        department_class = "sistemas";
        department_icon = "location_world";
        break;
      default:
        break;
    }

    return (
      <span className={"ticket-department dep-" + department_class}>
        <i className={"ticket-department-icon now-ui-icons " + department_icon} />
        {department_name}
      </span>
    );
  }
  buildTicketCategory(category) {
    if (!category) return null;
    // console.log("category", category);
    let category_id = parseInt(category.id);
    let category_name = category.name;
    let category_class = "";
    let category_icon = "";
    switch (category_id) {
      case 106: // Consulta
        category_class = "consulta";
        category_icon = "business_bulb-63";
        break;
      case 107: // Incidencia
        category_class = "incidencia";
        category_icon = "health_ambulance";
        break;
      case 309: // Soporte
        category_class = "soporte";
        category_icon = "emoticons_satisfied";
        break;
      default:
        break;
    }

    return (
      <span className={"ticket-category cat-" + category_class}>
        <i className={"ticket-category-icon now-ui-icons " + category_icon} />
        {category_name}
      </span>
    );
  }
  buildTicketPriority(priority) {
    if (!priority) return null;
    // console.log("state", state);
    let priority_id = parseInt(priority.id);
    let priority_name = priority.name;
    let priority_class = "";
    switch (priority_id) {
      case 110: // Baja
        priority_class = "baja";
        break;
      case 111: // Media
        priority_class = "media";
        break;
      case 112: // Alta
        priority_class = "alta";
        break;
      default:
        break;
    }

    return (
      <span className={"priority" + " prio-" + priority_class}>
        {priority_name}
      </span>
    );
  }
  buildTicketState(state) {
    if (!state) return null;
    // console.log("state", state);
    let state_id = parseInt(state.id);
    let state_name = state.name;
    let state_class = "";
    switch (state_id) {
      case 117: // Abierto
        state_class = "abierto";
        break;
      case 118: // Cerrado
        state_class = "cerrado";
        break;
      case 300: // Esperando respuesta
        state_class = "esperando";
        break;
      case 299: // Pendiente
        state_class = "pendiente";
        break;
      case 321: // Esperando respuesta
        state_class = "esperando";
        break;
      case 322: // Pendiente
        state_class = "pendiente";
        break;
      default:
        return null;
    }
    let result = [];
    result.push(
      <div key={"circle"} className={"circle-state state-" + state_class}></div>
    );
    result.push(
      <span key={"state"} className={"ticket-state state-" + state_class}>
        {state_name}
      </span>
    );

    return result;
  }
  isTicketClosed(state) {
    if (parseInt(state.id) === 118) return "ticket-closed";
  }
  buildTicketCustomer(customer) {
    if (!customer) return null;
    let result = null;

    result = (
      <div className="ticket-customer">
        <img className="ticket-customer-picture" src={customer.picture} alt={customer.name} />
        <span className="ticket-customer-name">{customer.name}</span>
      </div>
    );

    return result;
  }
  buildTicketAgent(agent) {
    let result = null;

    if (!agent || agent === null) {
      result = (
        <Col className="text-center">
          <div style={{padding:"10px"}}>Sin asignar</div>
        </Col>
      );
    } else {
      result = (
        <div className="ticket-customer">
          <img className="ticket-customer-picture" src={agent.picture} alt={agent.name} />
          <span className="ticket-customer-name">{agent.name}</span>
        </div>
      );
    }

    return result;
  }
  buildOpenedTicketsByDepartment(departments) {
    // console.log("statistics departments", departments);
    let result = [];

    if (departments && Object.keys(departments).length > 0) {
      result.push(
        <table className="ml-auto mr-auto departments-table" key={"departments-table"}>
          <tbody>
            {Object.keys(departments).map(department => {
              department = departments[department];
              return (
                <tr key={"department-count-" + department.id}>
                  <td className="text-left">
                    <span className="department-count">{department.count}</span>
                  </td>
                  <td className="text-left">{this.buildTicketDepartment(department)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      );
    }

    return result;
  }
  buildOpenedTicketsByCategory(categories) {
    // console.log("statistics categories", categories);
    let result = [];

    if (categories && Object.keys(categories).length > 0) {
      result.push(
        <table className="ml-auto mr-auto categories-table" key={"categories-table"}>
          <tbody>
            {Object.keys(categories).map(category => {
              category = categories[category];
              return (
                <tr key={"category-count-" + category.id}>
                  <td className="text-left">
                    <span className="category-count">{category.count}</span>
                  </td>
                  <td className="text-left">{this.buildTicketCategory(category)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      );
    }

    return result;
  }
  buildTicketsStatistics() {
    let statistics = this.props.state.tickets_statistics;
    // console.log("tickets statistics", this.props.state.tickets_statistics);
    let result = [];

    if (statistics) {
      result.push(
        <Row key="ticket-statistics">
          <Col>
            <Card>
              <CardBody>
                <Row key="ticket-list-statistics" className="text-center">
                  <Col {...this.state.ticketsStatisticsColsSize}>
                    <CardCategory>Tickets abiertos</CardCategory>
                    <CardTitle>{statistics.total}</CardTitle>
                  </Col>
                  <Col {...this.state.ticketsStatisticsColsSize}>
                    <CardCategory>Asignados</CardCategory>
                    <CardTitle>{statistics.assigned}</CardTitle>
                  </Col>
                  <Col {...this.state.ticketsStatisticsColsSize}>
                    <CardCategory>Por departamento</CardCategory>
                    {this.buildOpenedTicketsByDepartment(statistics.departments)}
                  </Col>
                  <Col {...this.state.ticketsStatisticsColsSize}>
                    <CardCategory>Por tipo</CardCategory>
                    {this.buildOpenedTicketsByCategory(statistics.categories)}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col xs={12} md={4} lg={2}>
            <Button
              // icon
              // round
              block
              key={"cancelAddPhotoButton"}
              color="info"
              onClick={() => {
                this.redirectTo("/tickets/nuevo");
              }}
              leftLabel={"now-ui-icons ui-1_simple-add"}
            >Nuevo ticket</Button>
          </Col>
        </Row>
      );
    } else {
      result.push(
        <Row key="ticket-list-statistics">
          <Col xs={12}>
            <Card>
              <CardBody>
                <div className="text-center">
                  <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando estadísticas...
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      );
    }

    return result;
  }
  passFilter(ticket) {
    try {
      let result = true;
      let partial_results = [true];
      let local_result = true;
      let local_var = null;
  
      let filters = this.state.filters;
      // console.log("filters", filters);
      Object.keys(filters).map(filter => {
        switch (filter) {
          case "reference":
            if (
              !ticket[filter]
                .toLowerCase()
                .includes(filters[filter].toLowerCase())
            )
              partial_results.push(false);
            break;
          case "title":
            if (
              !ticket[filter]
                .toLowerCase()
                .includes(filters[filter].toLowerCase())
            )
              partial_results.push(false);
            break;
          case "departments":
            local_result = false;
            local_var = filters[filter];
            local_var.map(department => {
              if (parseInt(ticket.department.id) === parseInt(department.value))
                local_result = true;
            });
            if (!local_var || local_var.length === 0) {
              partial_results.push(true);
            } else {
              partial_results.push(local_result);
            }
            break;
          case "categories":
            local_result = false;
            local_var = filters[filter];
            local_var.map(category => {
              if (parseInt(ticket.category.id) === parseInt(category.value))
                local_result = true;
            });
            if (!local_var || local_var.length === 0) {
              partial_results.push(true);
            } else {
              partial_results.push(local_result);
            }
            break;
          case "hide_closed":
            local_result = false;
            local_var = filters[filter];
            // Si el estado ID diferente de 118 (cerrado) pasa el filtro
            if (!local_var || (local_var && parseInt(ticket.state.id) !== 118)) local_result = true;
            partial_results.push(local_result);
            break;
          case "hide_answered":
            local_result = false;
            local_var = filters[filter];
            // Si el estado ID diferente de 118 (cerrado) pasa el filtro
            if (!local_var || (local_var && parseInt(ticket.substate.id) !== 300)) local_result = true;
            partial_results.push(local_result);
            break;
          case "only_own":
            local_result = false;
            local_var = filters[filter];
            // Si el estado ID diferente de 118 (cerrado) pasa el filtro
            // console.log("user en mainState", this.props.mainState.user);
            if (!local_var || (local_var && parseInt(ticket.author.id) === parseInt(this.props.mainState.user.uid))) local_result = true;
            partial_results.push(local_result);
            break;
          default:
            break;
        }
      });
  
      partial_results.map(current_result => (result = result && current_result));
  
      return result;
    } catch (error) {
      console.error("Error aplicando el filtro al ticket", ticket);
      return true;
    }
  }
  customFilter(option, searchText) {
    let label = ReactDOMServer.renderToStaticMarkup(option.label).toLowerCase();
    let result = true;
    let words = searchText.split(" ");
    if (words.length === 0) return false;
    for (let index = 0; index < words.length; index++) {
      const element = words[index];
      element.replace(/\s/g, '');
      if (element && element !== "")
        result = result && label.includes(element.toLowerCase());
    }
    return result;
  }
  cleanSelectWithHTML(options) {
    let result = null;

    if (options) {
      result = options.map(current => {
        return {
          value: current.value,
          label: <div dangerouslySetInnerHTML={{ __html: current.label }} />
        };
      });
    }

    return result;
  }
  buildTickets(tickets) {
    let result = [];

    result.push(this.buildTicketsStatistics());

    result.push(
      <Row key="ticket-list-header">
        <Col>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <FormGroup>
                    <Input
                      type="text"
                      placeholder="Número de ticket"
                      value={this.state.filters.reference || ""}
                      onChange={e => {
                        let filters = this.state.filters;
                        filters.reference = e.target.value;
                        this.setState({ filters: filters });
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Input
                      type="text"
                      placeholder="Concepto"
                      value={this.state.filters.title || ""}
                      onChange={e => {
                        let filters = this.state.filters;
                        filters.title = e.target.value;
                        this.setState({ filters: filters });
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      isMulti
                      closeMenuOnSelect={false}
                      placeholder="Seleccionar departamentos"
                      name="departments"
                      value={this.cleanSelectWithHTML(this.state.filters.departments)}
                      options={this.getDepartments()}
                      noOptionsMessage={() => "Cargando departamentos"}
                      onChange={value => {
                        let filters = this.state.filters;
                        value = value.map(currentValue => {
                          return {
                            value: currentValue.value,
                            label: ReactDOMServer.renderToStaticMarkup(currentValue.label)
                          };
                        });
                        filters.departments = value;
                        this.setState({ filters: filters });
                      }}
                      filterOption={this.customFilter}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      isMulti
                      closeMenuOnSelect={false}
                      placeholder="Seleccionar categorías"
                      name="categories"
                      value={this.cleanSelectWithHTML(this.state.filters.categories)}
                      options={this.getCategories()}
                      noOptionsMessage={() => "Cargando categorías"}
                      onChange={value => {
                        let filters = this.state.filters;
                        value = value.map(currentValue => {
                          return {
                            value: currentValue.value,
                            label: ReactDOMServer.renderToStaticMarkup(currentValue.label)
                          };
                        });
                        filters.categories = value;
                        this.setState({ filters: filters });
                      }}
                      filterOption={this.customFilter}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup check>
                    <Label check>
                      <Input 
                        type="checkbox"
                        defaultChecked={this.state.filters ? this.state.filters.hide_closed : false}
                        onChange={e => { 
                        // console.log("ocultar cerrados", e.target.checked);
                        let filters = this.state.filters;
                        filters.hide_closed = e.target.checked;
                        this.setState({ filters: filters });
                      }} />
                      <span className="form-check-sign" />
                      Ocultar cerrados
                    </Label>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup check>
                    <Label check>
                      <Input 
                        type="checkbox"
                        defaultChecked={this.state.filters ? this.state.filters.hide_answered : false}
                        onChange={e => { 
                          // console.log("ocultar cerrados", e.target.checked);
                          let filters = this.state.filters;
                          filters.hide_answered = e.target.checked;
                          this.setState({ filters: filters });
                        }} />
                      <span className="form-check-sign" />
                      Ocultar respondidos
                    </Label>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup check>
                    <Label check>
                      <Input 
                        type="checkbox"
                        defaultChecked={this.state.filters ? this.state.filters.only_own : false}
                        onChange={e => { 
                        // console.log("ocultar cerrados", e.target.checked);
                        let filters = this.state.filters;
                        filters.only_own = e.target.checked;
                        this.setState({ filters: filters });
                      }} />
                      <span className="form-check-sign" />
                      Solo abiertos por mí
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );

    result.push(
      <Row className="ticket-summup-header" key="ticket-summup-header">
        <div className="ticket-priority-header">
          Prio.
        </div>
        <Col xs={6} md={1}>
          Referencia
        </Col>
        <Col {...this.state.ticketsColsSize}>
          Concepto
        </Col>
        <Col {...this.state.ticketsColsSize}>
          Departamento
        </Col>
        <Col {...this.state.ticketsColsSize}>
          Estado
        </Col>
        <Col {...this.state.ticketsColsSize}>
          Víctima
        </Col>
        <Col {...this.state.ticketsColsSize}>
          Autor/Agente
        </Col>
      </Row>
    );

    Object.keys(tickets).reverse().map(ticket_id => {
      let ticket = tickets[ticket_id];
      let substate = this.buildTicketState(ticket.substate);
      if (substate) substate = (
        <span>
        {substate} <br />
        </span>
      );
      if (this.passFilter(ticket)) {
        result.push(
          <Col xs={12} key={ticket_id}>
            <Card
              className={
                "ticket-summup-wrapper " + this.isTicketClosed(ticket.state)
              }
              onClick={() => this.redirectTo("tickets/" + ticket_id)}
            >
              <CardBody>
                <Row className="ticket-summup">
                  <div className="ticket-priority">
                    {this.buildTicketPriority(ticket.priority)}
                  </div>
                  <Col xs={6} md={1}>
                    <span className="ticket-reference">#{ticket.reference}</span><br />
                    <span className="ticket-summup-date">{moment(ticket.date).fromNow()}</span>
                  </Col>
                  <Col {...this.state.ticketsColsSize}>
                    <span className="ticket-reference">{ticket.title}</span>
                  </Col>
                  <Col {...this.state.ticketsColsSize}>
                    {this.buildTicketDepartment(ticket.department)}<br />
                    <div className="wrapper-ticket-category">{this.buildTicketCategory(ticket.category)}</div>
                  </Col>
                  <Col {...this.state.ticketsColsSize}>
                    {this.buildTicketState(ticket.state)}<br />
                    {substate}
                    <span className="ticket-summup-date">{moment(ticket.last_comment).fromNow()}</span>
                  </Col>
                  <Col {...this.state.ticketsColsSize}>
                    {this.buildTicketCustomer(ticket.customer)}
                  </Col>
                  <Col {...this.state.ticketsColsSize}>
                    <Row>
                      <Col xs={12}>
                        {this.buildTicketAgent(ticket.agent)}
                      </Col>
                      <Col xs={12}>
                        {this.buildTicketAgent(ticket.author)}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
      }
    });

    return result;
  }
  render() {
    // this.buildTicketsStatistics();
    // console.log("######## PARAMS TOOLS ##########");
    // console.log(this.props.match.params);
    // console.log("_isToolSelected", _isToolSelected);
    let content = null;
    let tickets = this.props.state.tickets;
    if (tickets) {
      // console.log("Tickets cargados", tickets);
      if (Object.keys(tickets).length > 0) {
        content = this.buildTickets(tickets);
      } else {
        content = (
          <Row>
            <Col xs={12}>
              <Card className="text-center text-black" color="default">
                <CardBody>
                  <div className="text-center">
                    No hay tickets
                  </div>
                  <br />
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
      }
    } else {
      content = (
        <Row>
          <Col xs={12}>
            <Card className="text-center text-black" color="primary">
              <CardBody>
                <div className="text-center">
                  <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando tickets...
                </div>
                <br />
              </CardBody>
            </Card>
          </Col>
        </Row>
      );
    }
    return (
      <div>
        <PanelHeader
          size="sm"
          content={
            <div>
              {/* <h6 style={dashboardOrdersTitleStyle}>Herramientas</h6> */}
            </div>
          }
        />
        <div className="content">{content}</div>
      </div>
    );
  }
}

export default Tickets;



// WEBPACK FOOTER //
// ./src/views/Tickets/Tickets.jsx